import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    marginTop: "48px",
  },

  mobile_container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "0px 20px",
  },

  blackPopup_container: {
    position: "fixed",
    zIndex: 100,
    right: "38%",
  },

  mobile_blackPopup_container: {
    left: "15%",
    top: "60px",
    position: "fixed",
    zIndex: 100,
  },

  pageTitle: {
    color: "#000000",
    fontSize: "35px",
    letterSpacing: 0,
    marginBottom: "32px",
  },

  mobile_pageTitle: {
    color: "#000000",
    fontSize: "26px",
    letterSpacing: 0,
    marginBottom: "26px",
    marginTop: "12px",
  },

  inputSearch_container: {
    width: "100%",
  },

  tags_container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "24px",
    flexWrap: "wrap",
    padding: "24px 0px",
  },

  items_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
    width: "100%",
    marginBottom: "32px",
  },

  bottomDrawer_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "45.5px 20px 31.5px 20px",
    color: "#353535",
    fontSize: "18px",
    letterSpacing: 0,
    gap: "32px",
  },

  bottomDrawer_span: {
    cursor: "pointer",
  },

  loadMore_container: {
    marginBottom: "44px",
  },

  clearAll_container: {
    minWidth: "70px",
  },

  tagsAndClear_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "99%",
  },
}));

export default useStyles;
